export enum PaymentStatus {
    NotYetDue = 1,
    Due,
    Overdue,
    Paid,
}


// WEBPACK FOOTER //
// ./client/app/shared/payments/payment-types.enum.ts